import { EnvProfile } from "./types";

export const prodProfile: EnvProfile = {
  uiHostUrl: "https://admin.supamoto.app",
  apiHostUrl: "https://api.supamoto.app/api/v1",
  freshdeskUrl: "https://supamoto-help.freshdesk.com",
  queryCachingSeconds: 60
};
